import gsap from "gsap";

import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import SplitText from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// ScrollTrigger.normalizeScroll({ // モバイル ブラウザのアドレスバーの表示/非表示が防止される
//   allowNestedScroll: true, // これを指定しないと、横スクロール等ができなくなる可能性がある
//   lockAxis: false,
//   // momentum: self => Math.min(3, self.velocityY / 1000), // フリックスクロール時の勢いの継続時間を動的に制御
//   type: "touch,wheel,pointer", // リッスンするアクション
// });

const gsapAnim = () => {
  /**
   * create the smooth scroller
   */

  let smoother = ScrollSmoother.create({
    wrapper: "#smooth-wrapper",
    content: "#smooth-content",
    effects: true,
    smooth: 1.25,
    // speed: 0.8, // これを入れるとハッシュリンクのスクロール時にずれる(原因不明)
  });

  gsap.config({
    nullTargetWarn: false, // コンソールのtarget not foundを表示させない
  });

  /* css ブレイクポイントの値を取得 */
  const root = document.querySelector(":root");
  const breakPc = window.getComputedStyle(root).getPropertyValue("--break-pc");
  const breakmaxtab = window.getComputedStyle(root).getPropertyValue("--break-maxtab");

  /* タッチディバイスかどうかを判定する (if文の条件などに使用できる) */
  const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

  /**
   * loading 解除
   */

  // 1
  gsap.set("#page", {
    opacity: 0,
  });

  gsap.set("#loading", {
    opacity: 1,
  });

  const tl_loading = gsap.timeline();

  tl_loading.to("#loading", {
    opacity: 0,
    duration: 0.2,
    onComplete: () => {
      afterLoadingAnim();
    },
  });
  tl_loading.to("#page", {
    opacity: 1,
    duration: 0.2,
    ease: "power2.out",
  });

  function afterLoadingAnim() {
    /* *********************************************
			オープニングムービー
     ******************************************** */
    const openingMovieArea = document.querySelector("#openingMovie");
    const video = document.querySelector("#openingMovie video");
    const btnClose = document.querySelector(".close");
    const headerMain = document.querySelector("header.main");

    const closeMovie = () => {
      smoother.paused(false);
      if (btnClose) {
        gsap.to(btnClose, {
          opacity: 0,
          duration: 0.5,
          ease: "power2.out",
        });
      }
      gsap.to(video, {
        opacity: 0,
        duration: 1,
        delay: 0.1,
        ease: "power2.out",

        onComplete: () => {
          //#openingMovieをDOM的に削除
          openingMovieArea.remove();
          // ヘッダーを非表示
          gsap.to(headerMain, {
            opacity: 1,
            // pointerEvents: "auto",
            duration: 1,
            ease: "power2.out",
          });
        },
      });
    };

    if (jQuery.cookie("access") == undefined) {
      /* アクセス1回目の処理 */
      jQuery.cookie("access", "onece");

      smoother.paused(true);
      gsap.set(headerMain, {
        opacity: 0,
        // pointerEvents: "none"
      });

      if (video) {
        video.play(); //動画の再生
        btnClose.addEventListener("touchstart", function () {
          closeMovie();
        });
        btnClose.addEventListener("click", function () {
          closeMovie();
        });
        //動画が終了したことを検出して発火する処理
        video.addEventListener("ended", function () {
          closeMovie();
        });
      }
    } else {
      /* アクセス2回目以降の処理 */
      if (openingMovieArea) {
        openingMovieArea.remove();
      }
    }

    /* *********************************************
			ヘッダーナビ
     ******************************************** */
    const navInner = document.querySelector(".nav-bar .inner");
    const headerMenu = document.querySelector("#headerMenu");
    const navToggle = document.querySelector(".nav-mobile-toggle");

    // const navInner = document.querySelector(".nav-bar .inner");

    // gsap.set(navInner, { pointerEvents: "none" });

    // ナビを表示

    let openNav = gsap.timeline();
    openNav.to(navInner, {
      pointerEvents: "auto",
    });
    openNav.to(headerMenu, {
      xPercent: 0,
      opacity: 1,
      // pointerEvents: "auto",
      duration: 0.3,
      ease: "power2.out",
    });
    // openNav.to(navInner, {
    //   pointerEvents: "auto",
    // });
    openNav.pause();

    const navToggleShow = (e) => {
      e.preventDefault();
      e.stopPropagation();

      navToggle.classList.toggle("show");

      if (navToggle.classList.contains("show")) {
        openNav.play();
        smoother.paused(true);
      } else {
        openNav.reverse();
        smoother.paused(false);
      }
    };
    //セレクタの初期状態を設定する
    if (window.matchMedia(`(max-width: ${breakmaxtab}px)`).matches) {
      //セレクタの初期状態を設定する
      gsap.set(headerMenu, {
        xPercent: -100,
        opacity: 0,
        // pointerEvents: "none",
      });
      gsap.set(navInner, {
        pointerEvents: "none",
      });

      if (isTouchDevice) {
        navToggle.addEventListener("touchstart", navToggleShow);
      } else {
        navToggle.addEventListener("click", navToggleShow);
      }
    }
    /* *********************************************
			アンカーリンクのスクロールアニメーション
     ********************************************* */
    const headerHeight = document.querySelector("header.site-header").clientHeight;
    const offset = headerHeight;

    // ナビ内のリンク
    let links = document.querySelectorAll("ul.menu a[href*='#']");
    function anchorScrollAnim(button) {
      button.addEventListener("click", (e) => {
        navToggleShow(e);
        let id = e.currentTarget.getAttribute("href");
        smoother.scrollTo(id, true, `top ${offset}px`);
        e.preventDefault();
        e.stopPropagation();
      });
    }

    // コンテンツ内のリンク
    links = document.querySelectorAll(".main-container a[href*='#']");
    function anchorScrollAnim(button) {
      button.addEventListener("click", (e) => {
        let id = e.currentTarget.getAttribute("href");
        smoother.scrollTo(id, true, `top ${offset}px`);
        e.preventDefault();
        e.stopPropagation();
      });
    }

    links.forEach(function (button, i) {
      anchorScrollAnim(button);
    });

    /* ハッシュリンクの場合、遷移時に該当の箇所までアニメーションさせる */
    let urlHash = window.location.href.split("#")[1];
    let scrollElem = document.querySelector("#" + urlHash);

    if (urlHash && scrollElem) {
      gsap.to(smoother, {
        scrollTop: smoother.offset(scrollElem, `top ${offset}px`),
        duration: 1,
        delay: 2,
      });
    }

    /* *********************************************
			アニメーション
     ******************************************** */
    // .btn アニメーション
    let btns = document.querySelectorAll(".btn");
    btns.forEach((btn) => {
      if (btn.classList.contains("default")) {
        let tl = gsap.timeline({ paused: true }).to(btn, {
          duration: 0.1,
          backgroundColor: "#077f43",
          scale: 1.02,
          ease: "power2.out",
        });

        btn.addEventListener("mouseenter", () => tl.play());
        btn.addEventListener("mouseleave", () => tl.reverse());
      }
      if (btn.classList.contains("light")) {
        let tl = gsap.timeline({ paused: true }).to(btn, {
          duration: 0.1,
          backgroundColor: "#cbcbcb",
          scale: 1.02,
          ease: "power2.out",
        });

        btn.addEventListener("mouseenter", () => tl.play());
        btn.addEventListener("mouseleave", () => tl.reverse());
      }
    });

    /**
     * パララックス
     * ※ 対象の要素に、「class="parallax" data-y="-(数字)"」 を付与すること
     */
    gsap.utils.toArray(".parallax").forEach((elem) => {
      const defaultY = -40;

      /* data-y値はパララックスの振り幅 (必ず負の数値) */

      // .parallax要素のdata-y属性を取得。なければデフォルト値を格納
      const y = elem.getAttribute("data-y") || defaultY;

      gsap.set(elem, {
        y: -y, // 正の数値に変換し、y値をセット
      });

      gsap.to(elem, {
        y: y,
        scrollTrigger: {
          trigger: elem,
          start: "top bottom",
          end: "bottom top",
          scrub: 3.0,
          //markers: true
        },
      });
    });

    /**
     * 共通
     */
    // ヘディング
    const headings = document.querySelectorAll(".heading");

    headings.forEach((heading) => {
      console.log();
      gsap.fromTo(
        heading,
        {
          opacity: 0,
          y: 10,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power2.out",
          stagger: 0.2,
          scrollTrigger: {
            trigger: heading,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none play none",
          },
        }
      );
    });
    // ボタンボックス
    const btnBoxs = document.querySelectorAll(".btn-box");

    btnBoxs.forEach((btnBox) => {
      console.log();
      gsap.fromTo(
        btnBox,
        {
          opacity: 0,
          y: 10,
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: "power2.out",
          stagger: 0.2,
          scrollTrigger: {
            trigger: btnBox,
            start: "top 80%",
            end: "bottom 20%",
            toggleActions: "play none play none",
          },
        }
      );
    });
    /**
     * セミナー
     */
    // テーマ - タイトル
    gsap.fromTo(
      "#theme .title-box",
      {
        opacity: 0,
        y: 20,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: "#theme .title-box",
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none play none",
          // markers: true,
        },
      }
    );
    // テーマ - 説明文
    gsap.fromTo(
      "#theme .theme-desc",
      {
        opacity: 0,
        y: 20,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: "#theme .theme-desc",
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none play none",
          // markers: true,
        },
      }
    );

    // // 講演者紹介
    // gsap.fromTo(
    //   "#speaker .gs-item > *",
    //   {
    //     opacity: 0,
    //     y: 10,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     duration: 0.5,
    //     ease: "power2.out",
    //     stagger: 0.2,
    //     scrollTrigger: {
    //       trigger: "#speaker .gs-item",
    //       start: "top 80%",
    //       end: "bottom 20%",
    //       toggleActions: "play none play none",
    //     },
    //   }
    // );

    // // セミナー概要
    // gsap.fromTo(
    //   "#overview .gs-item",
    //   {
    //     opacity: 0,
    //     y: 10,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     duration: 0.5,
    //     ease: "power2.out",
    //     stagger: 0.2,
    //     scrollTrigger: {
    //       trigger: "#overview .gs-item",
    //       start: "top 80%",
    //       end: "bottom 20%",
    //       toggleActions: "play none play none",
    //     },
    //   }
    // );

    gsap.fromTo(
      "#topOpeningSeminar .desc",
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: "#topOpeningSeminar .desc",
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none play none",
        },
      }
    );

    // topEvent
    gsap.fromTo(
      "#topEvent .gs-item",
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: "#topEvent .gs-item",
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none play none",
        },
      }
    );
    // 研究シーズ集
    gsap.fromTo(
      "#seeds .gs-item",
      {
        opacity: 0,
        y: 10,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: "#seeds .gs-item",
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none play none",
        },
      }
    );
  } // end afterLoadingAnim()

  /**
   * 下層ページ
   * */
  // ページタイトル

  const splitElem = document.querySelector(".split");
  const split = new SplitText(splitElem, { type: "words, chars", wordsClass: "word", charsClass: "char" });

  const tl_pageTitle = gsap.timeline();
  tl_pageTitle
    .fromTo(".under-layer .overlay", 0.8, { x: "-100%" }, { x: "0", ease: "Power2.easeInOut" }, "+=0.8")
    .addLabel("anim")
    .staggerFromTo(".split .char", 0.5, { opacity: 0, x: 10 }, { opacity: 1, x: 0, ease: "Power2.easeInOut" }, 0.05, "up-=0.6")
    .fromTo(".text-box .subtitle", 0.4, { opacity: 0, x: "-20" }, { opacity: 1, x: "0", ease: "Power2.easeInOut" }, "m-=0.4");
};

export default gsapAnim;
